/* (c) Copyright Frontify Ltd., all rights reserved. */

export const SUPERSCRIPT_PLUGIN = 'superscript-plugin';
